import {ChangeDetectorRef, Component, Injector, Input, OnInit, Output, EventEmitter, ChangeDetectionStrategy, OnChanges, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {Comentario} from '../../_models/comentario';
import {ComentariosService} from './comentarios.service';
import {AccountService} from '../../_services/account.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CustomAlertService} from '../custom-alert/custom-alert.service';
import {environment} from 'src/environments/environment';

const API_URL = environment.apiUrl;

@Component({
  selector: 'glm-comentarios',
  standalone: false,
  templateUrl: 'glm-comentarios.component.html',
  styleUrls: ['glm-comentarios.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class GlmComentariosComponent implements OnInit, OnChanges {

  _comentarios: Comentario[];
  _targetID: number | string;
  _origen: string;
  _fechas: any[];

  @Input()
  comentarios: Comentario[] = [];
  @Input()
  targetID: number | string;
  @Input()
  origen: string;
  @Input()
  fechas: any[];
  @Input()
  allowCreate = true;
  @Input()
  allowResponse: boolean = true;
  @Input()
  textoPlaceHolder: string = 'Comentario';
  @Output()
  submit: EventEmitter<any>;

  nuevoComentario = '';
  selectedDate = '';

  loggedUser;

  constructor(private fb: UntypedFormBuilder,
              private injector: Injector,
              private comsService: ComentariosService,
              private accountService: AccountService,
              private cdRef: ChangeDetectorRef,
              private snackBar: MatSnackBar,
              private customAlertService: CustomAlertService,
              private changeDetectorRef: ChangeDetectorRef) {
    this.submit = new EventEmitter();
  }

  ngOnInit() {
    this._comentarios = this.injector.get('comentarios', null);
    this._targetID = this.injector.get('targetID', null);
    this._origen = this.injector.get('origen', null);
    this._fechas = this.injector.get('fechas', null);
    if (this._comentarios != null) {
      this.comentarios = this._comentarios;
    }
    if (this._targetID != null) {
      this.targetID = this._targetID;
    }
    if (this._origen != null) {
      this.origen = this._origen;
    }
    if (this._fechas != null) {
      this.fechas = this._fechas;
    }
  }

  ngOnChanges(changes: SimpleChanges = null): void {
    this.changeDetectorRef.detectChanges();
  }

  responderComentario(comentario) {
    if (!comentario.comentarios) {
      comentario.comentarios = [];
    }
    if (comentario.comentarios.filter(com => +com.id === 0).length === 0) {
      comentario.responder = true;
    }
  }

  guardarComentario(element, targetID, origen) {
    this.submit.emit();
    const modelo = {
      comentario: new Comentario({
        id: '0',
        comentario: element.value,
        fecha: this.selectedDate
      }), targetID, tipo: origen
    };

    this.comsService.guardarComentario(modelo, `${API_URL}/api/comentarios/crear`).subscribe(res => {
      if (origen === 'comentario') {
        const currComentario = this.comentarios.find(comentario => +comentario.id === +targetID);
        currComentario.comentarios.push(new Comentario(this.comsService.extractData(res)));
        currComentario.responder = false;
      } else {
        this.comentarios = this.prepend(new Comentario(this.comsService.extractData(res)), this.comentarios);
        element.value = '';
      }
      this.ngOnChanges();
      this.comsService.actualizarCuentaComentariosObjeto(this.targetID, this.origen, 'actualizar-cuenta-guardar', 1);
      this.selectedDate = '';
      this.snackBar.open(`El comentario fue creado.`, null, {duration: 2500});
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `El comentario no se ha podido crear. <br> Código de error: ${err.statusText}`
      });
    });
  }

  activarEdicion(comentario, estado) {
    comentario.editando = estado;
    this.cdRef.detectChanges();
  }

  editarComentario(value, comentario) {
    const comentarioEditado = Object.assign({}, comentario);
    comentarioEditado.comentario = value;
    this.comsService.actualizarComentario(comentarioEditado).subscribe(res => {
      comentario.comentario = value;
      comentario.editando = false;
      this.snackBar.open(`El comentario fue actualizado correctamente.`, null, {duration: 2500});
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `El comentario no se ha podido actualizar. <br> Código de error: ${err.statusText}`
      });
    });
  }

  marcarLeido(comentario) {
    this.comsService.marcarLeido(comentario.id).subscribe(res => {
      comentario.leido = true;
      comentario.leidoPor.push(res);
      this.snackBar.open(`El comentario fue marcado como leído.`, null, {duration: 2500});
      this.comsService.actualizarCuentaComentariosObjeto(this.targetID, this.origen, 'actualizar-cuenta');
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `El comentario no se ha podido marcar como leído. <br> Código de error: ${err.statusText}`
      });
    });
  }

  eliminarComentario(comentario, parentID) {
    let contenedor,
      indice = -1;

    if (parentID > 0) {
      contenedor = this.comentarios.find(com => +com.id === +parentID);
    }

    this.comsService.eliminarComentario(comentario.id).subscribe(res => {
      if (parentID > 0) {
        indice = contenedor.comentarios.findIndex(resp => +resp.id === +comentario.id);
        contenedor.comentarios.splice(indice, 1);
      } else {
        indice = this.comentarios.findIndex(com => +com.id === +comentario.id);
        this.comentarios.splice(indice, 1);
      }
      this.ngOnChanges();
      this.comsService.actualizarCuentaComentariosObjeto(this.targetID, this.origen, 'actualizar-cuenta-guardar', -1);
      this.snackBar.open(`El comentario fue eliminado.`, null, {duration: 2500});
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `El comentario no se ha podido eliminar. <br> Código de error: ${err.statusText}`
      });
    });
  }

  prepend(newComentario, arreglo) {
    const newComentarios = arreglo.slice();
    newComentarios.unshift(newComentario);
    return newComentarios;
  }
}
